import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../../../core/service/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule], // ✅ needed for *ngIf
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  constructor(public loader: LoaderService) {}

  get isLoading() {
    return this.loader.isLoading();
  }
}
